export let Environment = /*#__PURE__*/function (Environment) {
  Environment["PRODUCTION"] = "prod";
  Environment["STAGING"] = "staging";
  Environment["DEVELOPMENT"] = "dev";
  Environment["LOCAL"] = "local";
  return Environment;
}({});